import styles from '../Sales.module.css';

import { Avatar, Card } from '@mui/material';
import Scrollbar from '../../../components/scrollbar';
// sections
// mock
import SalesDetails from '../SalesDetails';
import { useEffect, useState } from 'react';
import { useLayoutEffect } from 'react';
import GlobalModal from 'src/Modals/GlobalModal';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { useAuth } from 'src/hooks/useAuth';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useNavigate } from 'react-router-dom';
import LiveLocation from 'src/pages/LiveLocation';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axiosInstance from 'src/axiosInstance';
import toast from 'react-hot-toast';
import moment from 'moment';
import { BallTriangle } from 'react-loader-spinner';
import CircularProgress from '@mui/material/CircularProgress';
import bus from 'src/bus';
import { Pagination } from 'src/components';
// ----------------------------------------------------------------------
import Filter1 from 'src/pages/Filter/Filter1';
import { downloadFile2 } from 'src/utils';

const TABLE_HEAD = [
  { id: 'customerName', label: 'Merchant', alignRight: false },
  { id: 'category', label: 'Category', alignRight: false },
  { id: 'productUnit', label: 'Product Purchased', alignRight: false },
  { id: 'customerLocation', label: 'Customer Location', alignRight: false },
  // { id: 'price', label: 'Product Cost', alignRight: false },
  { id: 'date_purchased', label: 'Date Purchased', alignRight: false },
  { id: 'total_quantity', label: 'Total Quantity', alignRight: false },
];
const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));
// ----------------------------------------------------------------------
// ptvs=PAGE TO VIEW (SALES)

let app_view = localStorage.getItem('ptvs') ?? 0;
export default function ShopOwners() {
  const { data } = useAuth();

  const [appView] = useState(app_view);
  const [showDiv] = useState(data.merchant_type === 'brand');
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState(null);
  const [exporting, setExporting] = useState(false);
  const [endDate, setEndDate] = useState(null);
  const [isPending, setIsPending] = useState(false);
  const [brandPending, setBrandPending] = useState(false);
  const [brandsData, setBrandsData] = useState([]);
  const [searchvalue, setSearchvalue] = useState('');
  const [dataFilter, setDataFilter] = useState({});
  const [dataPagination, setDataPagination] = useState({ total: 0 });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  // const notify = (msg = null) => toast.success(msg === null ? 'Store saved .' : msg);
  const notifyError = (err) => toast.error(err);
  const [tooltipData, setToolTipData] = useState({ product_items: [] });
  const [tooltipLoading, setToolTipLoading] = useState(false);
  const [filterSearch, setFilterSearch] = useState({
    min_patronage: '',
    max_patronage: '',
    min_price: 0,
    max_price: 0,
    min_order_unit: '',
    max_order_unit: '',
    min_amount: '',
    max_amount: '',
    category: '',
    location: '',
  });
  const [dataDetails, setDetailsData] = useState({
    total_sales: {
      current_total_sales: 0,
      previous_total_sales: 0,
      percentage_sales: 0,
    },
    total_products: {
      current_total_products: 0,
      previous_total_product: 0,
      percentage_abandoned: 0,
    },
  });

  const [modalOpen, setModalOpen] = useState(false);

  const handleClose = () => {
    setModalOpen(false);
  };

  const handleStatusChange = (key, value) => {
    setFilterSearch((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const processLocation = (e) => {
    // console.log(e);
  };

  useLayoutEffect(
    () => () => {
      localStorage.removeItem('ptvs');
    },
    []
  );

  const handleViewClick = (val) => {
    localStorage.setItem('brand_sales_details', JSON.stringify(val));
    navigate('/app/brand_sales_details');
    // handle view click action
  };

  const handleChange = (/* args passed from the child component */) => {
    handleViewClick(0);
  };

  const searchFilter = (e) => {
    setSearchvalue(e.target.value);
  };

  const fetchCardDetails = (period = dataFilter) => {
    setIsPending(true);
    let periodValue = typeof period === 'object' ? 'today' : period;
    axiosInstance
      .get('/brand/sales/cards?period=' + periodValue)
      .then((res) => {
        setDetailsData(res.data.data);
      })
      .catch((err) => {
        try {
          notifyError(err.response.data.message);
        } catch (error) {
          notifyError('Unable to fetch sales analytics, try again later');
        }
      })
      .finally(() => setIsPending(false));
  };

  useEffect(() => {
    fetchCardDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataFilter]);

  const fetchData = async (page = 1, pageSize = 10, file = null) => {
    let filter_payload = {};
    if (filterSearch.min_price) {
      filter_payload.min_price = filterSearch.min_price;
    }
    if (filterSearch.max_price) {
      filter_payload.max_price = filterSearch.max_price;
    }
    if (searchvalue !== '') {
      filter_payload.search = searchvalue;
    }
    if (startDate && startDate !== '') {
      filter_payload.dateFrom = startDate;
    }
    if (endDate && endDate !== '') {
      filter_payload.dateTo = endDate;
    }
    if (filterSearch.min_patronage !== '') {
      filter_payload.min_patronage = filterSearch.min_patronage;
    }
    if (filterSearch.max_patronage !== '') {
      filter_payload.max_patronage = filterSearch.max_patronage;
    }
    if (filterSearch.min_amount !== '') {
      filter_payload.min_amount = filterSearch.min_amount;
    }
    if (filterSearch.max_amount !== '') {
      filter_payload.max_amount = filterSearch.max_amount;
    }
    if (filterSearch.min_order_unit !== '') {
      filter_payload.min_order_unit = filterSearch.min_order_unit;
    }
    if (filterSearch.max_order_unit !== '') {
      filter_payload.max_order_unit = filterSearch.max_order_unit;
    }
    // if (filterSearch.status !== '' && filterSearch.status !== 'select') {
    //   filter_payload.status = filterSearch.status
    // }
    if (filterSearch.category !== '') {
      filter_payload.category = filterSearch.category;
    }
    if (filterSearch.location !== '') {
      filter_payload.location = filterSearch.location;
    }

    if (file) {
      let queryParams = new URLSearchParams({
        ...filter_payload,
        page,
        pageSize,
        export_type: file,
      }).toString();
      setExporting(true);

      try {
        await downloadFile2('All Sales', `/brand/sales?${queryParams}`, file);
      } finally {
        // alert()
        setExporting(false);
      }
      return;
    }
    setBrandPending(true);
    handleClose(false);
    setModalOpen(false);
    axiosInstance
      .get('/brand/sales?', {
        params: {
          page,
          pageSize,
          ...filter_payload,
        },
      })
      .then((res) => {
        // console.log(res.data.data);
        if (res.status < 300) {
          setBrandsData(res.data.data.data);
        }
        setDataPagination(res.data.data.pagination);
        setStartDate(null);
        setEndDate(null);
        setFilterSearch({
          min_patronage: '',
          max_patronage: '',
          min_price: 0,
          max_price: 0,
          min_order_unit: '',
          max_order_unit: '',
          min_amount: '',
          max_amount: '',
          category: '',
          location: '',
        });
      })
      .catch((err) => {
        try {
          notifyError(err.response.data.message);
        } catch (error) {
          notifyError('Unable to fetch subscriptions, try again later');
        }
      })
      .finally(() => setBrandPending(false));
  };

  useEffect(() => {
    bus.on('dataFilter', (el) => {
      // console.log(el);
      setDataFilter(el);
      fetchData();
    });
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchvalue]);

  const getHoverProduct = (id) => {
    setToolTipLoading(true);
    setToolTipData({ product_items: [] });
    axiosInstance
      .get(`/brand/sales/on-hover/${id}`)
      .then((res) => {
        setToolTipData(res.data.data[0] || { product_items: [] });
      })
      .catch((err) => {
        try {
          notifyError(err.response.data.message);
        } catch (error) {
          notifyError('Something went wrong , please try again later');
        }
      })
      .finally(() => setToolTipLoading(false));
  };

  return Number(appView) === 0 ? (
    <>
      <div className="pt-4">
        <div className={`${styles.analytics}  `}>
          <Filter1 width="100%" />
          <div className={`row`}>
            <div className={`col-md-12 mb-2`}>
              <div className={`${styles.card}`}>
                <div className={`card-body`}>
                  <div className="d-flex justify-content-between">
                    <small>Total Product Sold</small>
                  </div>
                  <div className={`${styles.numbers}`}>
                    <div>
                      <span>
                        {Number(
                          dataDetails?.total_products?.current_total_products
                        ).toLocaleString()}
                      </span>
                      <small className="pl-1">
                        from{' '}
                        {Number(
                          dataDetails?.total_products?.previous_total_product
                        ).toLocaleString()}
                      </small>
                    </div>
                    <div>
                      {Number(
                        dataDetails?.total_products?.current_total_products
                      ).toLocaleString() >=
                      Number(
                        dataDetails?.total_products?.previous_total_product
                      ).toLocaleString() ? (
                        <div className={styles.percent}>
                          <img src="/assets/icons/up.svg" alt="" />
                          <small className="pl-1">
                            {Math.floor(
                              Number(
                                dataDetails?.total_products
                                  ?.percentage_abandoned
                              )
                            )}
                            %
                          </small>
                        </div>
                      ) : (
                        <div className={`${styles.percent2}`}>
                          <img src="/assets/icons/downr.svg" alt="" />
                          <small className="pl-1">
                            {Math.abs(
                              dataDetails?.total_products?.percentage_abandoned
                            )}
                            %
                          </small>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className={`col-md-6 mb-2`}>
              <div className={`${styles.card}`}>
                <div className={`card-body`}>
                  <div className="d-flex justify-content-between">
                    <small>Total Sales</small>
                  </div>
                  <div className={`${styles.numbers}`}>
                    <div>
                      <span>
                        ₦ {Number(dataDetails?.total_sales?.current_total_sales).toLocaleString()}
                      </span>
                      <small className="pl-1">
                        from ₦ {Number(dataDetails?.total_sales?.previous_total_sales).toLocaleString()}
                      </small>
                    </div>
                    <div>
                      {
                        Number(dataDetails?.total_sales?.current_total_sales).toLocaleString() >=
                          Number(dataDetails?.total_sales?.previous_total_sales).toLocaleString() ?
                          <div className={styles.percent}>
                            <img src="/assets/icons/up.svg" alt="" />
                            <small className="pl-1">
                              {dataDetails?.total_sales?.percentage_sales}%
                            </small>
                          </div>
                          :
                          <div className={`${styles.percent2}`}>
                            <img src="/assets/icons/downr.svg" alt="" />
                            <small className="pl-1">
                              {Math.abs(dataDetails?.total_sales?.percentage_sales)}%
                            </small>
                          </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
        <div className={`${styles.filters} mt-4`}>
          <div className="row">
            <div className={`${styles.hold_input} col-md-3 col-6   `}>
              <img src="/assets/icons/search.svg" alt="" />
              <input
                type="text"
                value={searchvalue}
                onChange={searchFilter}
                placeholder="Search"
                style={{
                  textIndent: '25px',
                  width: '100%',
                }}
                className=" form-control"
              />
            </div>
            <div className="col-md-9 col-6  text-right">
              <button
                className="btn  border"
                onClick={() => setModalOpen(true)}
                style={{
                  backgroundColor: '#fff',
                  border: '1px solid #D0D5DD',
                  boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                  borderRadius: '4px',
                }}
              >
                <img
                  className=""
                  style={{
                    display: 'inline',
                    width: '28%',
                  }}
                  src="/assets/icons/filterlines.svg"
                  alt=""
                />
                &nbsp;
                <small className="d-none d-md-inline-block">Filters</small>
              </button>
            </div>
          </div>
        </div>
        <Card
          style={{ marginTop: '50px', borderRadius: '10px' }}
          className="p-0"
        >
          <div className="p-3 ">
            <div className="d-md-flex justify-content-between">
              <div className="pb-3 pb-md-0">
                <h5 className="table_desc_header">Recent sales</h5>
                <small style={{ fontWeight: '200', fontSize: '12px' }}>
                  Detailed Information of all recent Sales
                </small>
              </div>
              <div className="pt-md-2">
                <div className="dropleft ">
                  <button
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    className={`${styles.export_btn} btn m-0`}
                  >
                    <span
                      style={{
                        paddingTop: '8px',
                      }}
                    >
                      <img src="/assets/icons/download.svg" alt="" /> &nbsp;
                      {!exporting && <span>Export</span>}
                      {exporting && (
                        <CircularProgress
                          style={{
                            color: 'white',
                            display: 'inline-block',
                          }}
                          size="1rem"
                        />
                      )}
                    </span>
                    &nbsp; &nbsp;
                    <span
                      style={{
                        borderLeft: '1px solid white',
                        display: 'inline-block',
                        height: 'inherit',
                        paddingTop: '8px',
                        paddingLeft: '8px',
                        textAlign: 'center',
                      }}
                    >
                      <img src="/assets/icons/arrowDown.svg" alt="" />
                    </span>
                  </button>
                  <div
                    className="dropdown-menu drop-left"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <button
                      onClick={() => fetchData(currentPage, 200000, 'csv')}
                      type="button"
                      className="rss dropdown-item btn border-0"
                    >
                      CSV
                    </button>
                    <button
                      onClick={() => fetchData(currentPage, 200000, 'excel')}
                      type="button"
                      className="rss dropdown-item btn border-0"
                    >
                      Excel
                    </button>
                    <button
                      onClick={() =>
                        fetchData(currentPage, itemsPerPage, 'pdf')
                      }
                      type="button"
                      className="rss dropdown-item btn border-0"
                    >
                      PDF
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Scrollbar>
            <div className={`pt-3 pb-3 pl-0 pr-0`}>
              <table
                className={`${styles.table} table-hover table-striped`}
                style={{ minWidth: '100em' }}
              >
                <thead className={`${styles.thead}`}>
                  <tr>
                    {TABLE_HEAD.map((el, i) => {
                      let sIndex = i < 1 ? 1 : false;
                      return (
                        <th key={i} className="text-muted">
                          {el.label}{' '}
                          {sIndex && (
                            <span style={{ cursor: 'pointer' }}>
                              <img
                                className="pl-2"
                                src="/assets/icons/down.svg"
                                alt=""
                              />
                            </span>
                          )}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {!brandPending &&
                    brandsData.length > 0 &&
                    brandsData?.map((el, i) => (
                      <tr key={el?._id} className={`${styles.tr}`}>
                        <td>
                          <div className=" ">
                            <Avatar
                              className="float-md-left  mr-2"
                              src={el?.shop_logo}
                              alt=""
                              style={{ width: '50px', height: '50px' }}
                            />
                            <div className=" ">
                              <p className="mb-0" style={{ fontSize: '14px' }}>
                                <strong>{el?.shop_name}</strong>
                              </p>
                              <span style={{ fontSize: '10px' }}>
                                {el?.order_number}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <p>{el?.category}</p>
                        </td>
                        <td className="text-center">
                          <p className="text-center">
                            <BootstrapTooltip
                              title={
                                <div>
                                  {!tooltipLoading &&
                                    tooltipData.product_items.length > 0 &&
                                    tooltipData.product_items.map(
                                      (tooltip, ind) => (
                                        <span key={ind} className="mr-1">
                                          {tooltip.product_name},
                                        </span>
                                      )
                                    )}
                                  {!tooltipLoading &&
                                    tooltipData.product_items.length < 1 && (
                                      <span>Empty</span>
                                    )}
                                  {tooltipLoading && <span>Loading</span>}
                                </div>
                              }
                            >
                              <span
                                onMouseEnter={() => getHoverProduct(el._id)}
                              >
                                {el?.product_purchased}
                              </span>
                            </BootstrapTooltip>
                          </p>
                        </td>
                        <td>
                          <p>{el?.customer_location}</p>
                        </td>
                        <td>
                          <p className="text-center">
                            {moment(el?.date_ordered).format('DD/MM/YYYY')}
                          </p>
                        </td>
                        <td className="text-center">
                          {Number(el?.total_quantity).toLocaleString()}
                        </td>
                        {/* <td>
                          <div className="dropleft ">
                            <span
                              id="dropdownMenuButton"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                              className={`${styles.action_button} px-3 py-2`}
                              style={{
                                cursor: 'pointer',
                              }}>
                              <img
                                src="/assets/icons/action.svg"
                                alt=""
                              />
                            </span>
                            <div
                              className="dropdown-menu drop-left"
                              aria-labelledby="dropdownMenuButton"
                            >
                              <button
                                type="button"
                                onClick={() => handleViewClick(el)}
                                className="rss dropdown-item btn border-0">
                                View
                              </button>
                            </div>
                          </div>
                        </td> */}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-center">
              {brandPending && (
                <BallTriangle
                  height={50}
                  width={55}
                  radius={5}
                  color="#af3585"
                  ariaLabel="ball-triangle-loading"
                  wrapperClass={{}}
                  wrapperStyle=""
                  visible={true}
                />
              )}
            </div>
            {!brandsData?.length && !brandPending && (
              <div className="alert alert-[#af3585] text-center">
                <h4>No record found</h4>
              </div>
            )}
          </Scrollbar>
          <div>
            <Pagination
              currentPage={currentPage}
              dataPagination={dataPagination}
              itemsPerPage={itemsPerPage}
              setCurrentPage={setCurrentPage}
              fetchData={fetchData}
            />
          </div>
        </Card>
      </div>
      <GlobalModal
        open={modalOpen}
        onClose={() => fetchData()}
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        width="740px !important"
        overflow="auto"
        bgcolor="#FFFFFF"
        border="1px solid #F5F5F5"
        borderRadius="5px"
        boxShadow="24"
        p="25px"
      >
        <div className={`${styles.modal_content}`}>
          <div className={`${styles.modal_header} mb-0`}>
            <h5
              style={{
                fontSize: '19px',
                fontWeight: '700',
              }}
            >
              Filter
            </h5>
            <span onClick={() => fetchData()} style={{ cursor: 'pointer' }}>
              <img src="/assets/icons/x.svg" alt="" />
            </span>
          </div>
          <form action="" className="mt-0 form_label">
            <div className="row">
              <div className="col-md-6 mb-1">
                <div className="mb-3">
                  <LiveLocation label="Location" passData={processLocation} />
                </div>
                <label htmlFor="ounit">Order Unit </label>
                <div className=" d-flex">
                  <div className="" style={{ width: '100%' }}>
                    <div className="mb-3">
                      <TextField
                        required
                        type="number"
                        id="ounit"
                        placeholder="Min"
                        size="small"
                        value={filterSearch.min_order_unit}
                        name="min_order_unit"
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          if (
                            inputValue === '' ||
                            parseFloat(inputValue) >= 0
                          ) {
                            handleStatusChange('min_order_unit', inputValue);
                          }
                        }}
                        inputProps={{
                          inputMode: 'decimal',
                        }}
                        onKeyDown={(e) => {
                          if (e.key === '-' || e.key === 'e' || e.key === '.') {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className="px-1 d-flex align-items-center "
                    style={{ height: '40px' }}
                  >
                    <img
                      src="/assets/icons/line.svg"
                      style={{
                        width: '30px',
                      }}
                      alt=""
                    />
                  </div>
                  <div className="" style={{ width: '100%' }}>
                    <div className="mb-3">
                      <TextField
                        required
                        type="number"
                        placeholder="Max "
                        size="small"
                        value={filterSearch.max_order_unit}
                        name="max_order_unit"
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          if (
                            inputValue === '' ||
                            parseFloat(inputValue) >= 0
                          ) {
                            handleStatusChange('max_order_unit', inputValue);
                          }
                        }}
                        inputProps={{
                          inputMode: 'decimal',
                        }}
                        onKeyDown={(e) => {
                          if (e.key === '-' || e.key === 'e' || e.key === '.') {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="name">Category</label>
                  <Select
                    labelId="s"
                    id="s"
                    fullWidth
                    size="small"
                    placeholder="Select category"
                    required
                    value={filterSearch.category}
                    onChange={(e) =>
                      handleStatusChange('category', e.target.value)
                    }
                    name="category"
                  >
                    <MenuItem value="select">Select Category</MenuItem>
                    <MenuItem value="Kiosk">Kiosk</MenuItem>
                    <MenuItem value="Neighborhood store">
                      Neighborhood store
                    </MenuItem>
                    <MenuItem value="Supermarket">Supermarket</MenuItem>
                    <MenuItem value="E-commerce store">
                      E-commerce store
                    </MenuItem>
                  </Select>
                </div>
              </div>
              <div className="col-md-6 mb-1">
                <label htmlFor="price">Product Cost </label>
                <div className=" d-flex">
                  <div className="" style={{ width: '100%' }}>
                    <div className="mb-3">
                      <TextField
                        required
                        type="number"
                        id="price"
                        placeholder="Min"
                        size="small"
                        value={filterSearch.min_price}
                        name="min_price"
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          if (
                            inputValue === '' ||
                            parseFloat(inputValue) >= 0
                          ) {
                            handleStatusChange('min_price', inputValue);
                          }
                        }}
                        inputProps={{
                          inputMode: 'decimal',
                        }}
                        onKeyDown={(e) => {
                          if (e.key === '-' || e.key === 'e' || e.key === '.') {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className="px-1 d-flex align-items-center"
                    style={{
                      height: '40px',
                    }}
                  >
                    <img
                      src="/assets/icons/line.svg"
                      style={{
                        width: '30px',
                      }}
                      alt=""
                    />
                  </div>
                  <div className="" style={{ width: '100%' }}>
                    <div className="mb-3">
                      <TextField
                        required
                        type="number"
                        placeholder="Max "
                        size="small"
                        value={filterSearch.max_price}
                        name="max_price"
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          if (
                            inputValue === '' ||
                            parseFloat(inputValue) >= 0
                          ) {
                            handleStatusChange('max_price', inputValue);
                          }
                        }}
                        inputProps={{
                          inputMode: 'decimal',
                        }}
                        onKeyDown={(e) => {
                          if (e.key === '-' || e.key === 'e' || e.key === '.') {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
                {showDiv && (
                  <div>
                    <label htmlFor="ora">Cummulative Amount </label>
                    <div className=" d-flex">
                      <div className="" style={{ width: '100%' }}>
                        <div className="mb-3">
                          <TextField
                            required
                            type="number"
                            id="ora"
                            placeholder="Min"
                            size="small"
                            value={filterSearch.min_amount}
                            name="min_amount"
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              if (
                                inputValue === '' ||
                                parseFloat(inputValue) >= 0
                              ) {
                                handleStatusChange('min_amount', inputValue);
                              }
                            }}
                            inputProps={{
                              inputMode: 'decimal',
                            }}
                            onKeyDown={(e) => {
                              if (
                                e.key === '-' ||
                                e.key === 'e' ||
                                e.key === '.'
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </div>
                      </div>
                      <div
                        className="px-1 d-flex align-items-center "
                        style={{
                          height: '40px',
                        }}
                      >
                        <img
                          src="/assets/icons/line.svg"
                          style={{ width: '30px' }}
                          alt=""
                        />
                      </div>
                      <div className="" style={{ width: '100%' }}>
                        <div className="mb-3">
                          <TextField
                            required
                            type="number"
                            placeholder="Max "
                            size="small"
                            value={filterSearch.max_amount}
                            name="max_amount"
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              if (
                                inputValue === '' ||
                                parseFloat(inputValue) >= 0
                              ) {
                                handleStatusChange('max_amount', inputValue);
                              }
                            }}
                            inputProps={{
                              inputMode: 'decimal',
                            }}
                            onKeyDown={(e) => {
                              if (
                                e.key === '-' ||
                                e.key === 'e' ||
                                e.key === '.'
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <label htmlFor="name">Date </label>
                    <div className=" d-flex">
                      <div className="" style={{ width: '48%' }}>
                        <div className="mb-3">
                          <DatePicker
                            showIcon
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            dateFormat="dd/MM/yyyy"
                            className="form-control"
                            placeholderText="Start"
                            required
                            maxDate={new Date()}
                          />
                        </div>
                      </div>
                      <div
                        className="px-1 d-flex align-items-center"
                        style={{
                          height: '40px',
                        }}
                      >
                        {/* sss */}
                        <img
                          src="/assets/icons/line.svg"
                          style={{
                            width: '14px',
                          }}
                          alt=""
                        />
                      </div>
                      <div className="" style={{ width: '48%' }}>
                        <div className="mb-3">
                          <DatePicker
                            showIcon
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            dateFormat="dd/MM/yyyy"
                            className="form-control"
                            placeholderText="End"
                            required
                            maxDate={new Date()}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {!showDiv && (
                  <div>
                    <label htmlFor="patronage">Patronage </label>
                    <div className=" d-flex">
                      <div className="" style={{ width: '100%' }}>
                        <div className="mb-3">
                          <TextField
                            required
                            type="number"
                            id="patronage"
                            placeholder="Min"
                            size="small"
                            value={filterSearch.min_patronage}
                            name="min_patronage"
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              if (
                                inputValue === '' ||
                                parseFloat(inputValue) >= 0
                              ) {
                                handleStatusChange('min_patronage', inputValue);
                              }
                            }}
                            inputProps={{
                              inputMode: 'decimal',
                            }}
                            onKeyDown={(e) => {
                              if (
                                e.key === '-' ||
                                e.key === 'e' ||
                                e.key === '.'
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </div>
                      </div>
                      <div
                        className="px-1 d-flex align-items-center"
                        style={{
                          height: '40px',
                        }}
                      >
                        <img
                          src="/assets/icons/line.svg"
                          style={{
                            width: '30px',
                          }}
                          alt=""
                        />
                      </div>
                      <div className="" style={{ width: '100%' }}>
                        <div className="mb-3">
                          <TextField
                            required
                            type="number"
                            placeholder="Max "
                            size="small"
                            value={filterSearch.max_patronage}
                            name="max_patronage"
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              if (
                                inputValue === '' ||
                                parseFloat(inputValue) >= 0
                              ) {
                                handleStatusChange('max_patronage', inputValue);
                              }
                            }}
                            inputProps={{
                              inputMode: 'decimal',
                            }}
                            onKeyDown={(e) => {
                              if (
                                e.key === '-' ||
                                e.key === 'e' ||
                                e.key === '.'
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="mb-4">
              <button
                type="button"
                onClick={() => fetchData()}
                className={`${styles.modal_btn} btn btn-block`}
              >
                Proceed
              </button>
            </div>
          </form>
        </div>
      </GlobalModal>
    </>
  ) : (
    <SalesDetails key={1} onChange={handleChange} />
  );
}
